import CustomCard from '../../../elements/CustomCard'
import React from 'react'

function ReportCards(props) {
  return (
    <div style={{ background: '#f0f2f5', padding: '30px' }}>
      <CustomCard
        {...{
          title: 'Activity Report',
          iconType: 'team',
          color: '#FF6B6B',
          linkTo: '/corporates/analytics/activity',
          description: 'Access Your important document and operation.',
        }}
      />

      <CustomCard
        {...{
          title: 'Vendor Report',
          iconType: 'login',
          color: '#E6C385',
          linkTo: '/corporates/analytics/vendor',
          description: 'Access Your important document and operation.',
        }}
      />

      <CustomCard
        {...{
          title: 'Client Report',
          iconType: 'logout',
          color: '#4ECDC4',
          linkTo: '/corporates/analytics/client',
          description: 'Access Your important document and operation.',
        }}
      />

      <CustomCard
        {...{
          title: 'Sales Contribution Report',
          iconType: 'money-collect',
          color: '#1A535C',
          linkTo: '/corporates/analytics/salesContribution',
          description: 'Access Your important document and operation.',
        }}
      />

      <CustomCard
        {...{
          title: 'Purchases And PayPlan Report',
          iconType: 'dollar',
          color: '#1A535C',
          linkTo: '/corporates/analytics/purchasesAndPayPlanReport',
          description: 'Access Your important document and operation.',
        }}
      />
    </div>
  )
}

export default ReportCards
